import styled from '@emotion/styled';
import {tokens} from '../../../public/tokens';

/**
 * Flexible, scrollable container that wraps content
 * and occupies the viewport height minus the header (48px).
 */
export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  background: ${tokens.colors.surfaces['page-background']};
`;


/**
 * ContainerWrapper - Standard container for page content
 * @param {boolean} $border - Show border when true
 */
export const ContainerWrapper = styled.div`
  background: ${props => props.background ?? tokens.colors.surfaces['container-background']};
  border-radius: ${tokens.globals['border-radius']};
  border: ${props => props.border ? `1px solid ${tokens.colors.surfaces['border-divider']}` : 'none'};
  padding: ${props => props.padding ?? tokens.globals['spacing-lg']};
  box-shadow: ${tokens.effects.effects.shadow.default};
  ${({ outline = true }) =>  outline ? `border: 1px solid ${tokens.colors.surfaces['border-divider']};` : `border: none;`}
`;